
import HeroSection from './components/HeroSection';
import LiveSection from './components/LiveSection';
import AISection from './components/AISection';
import FilmHumanitiesSection from './components/FilmHumanitiesSection';
import AboutSection from './components/AboutSection';
import WhySection from './components/WhySection';
import ChurchSection from './components/ChurchSection';
import ResearcherSection from './components/ResearcherSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <WhySection />
      <ChurchSection />
      <ResearcherSection />
      <LiveSection />
      <AISection />
      <FilmHumanitiesSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
